import React from "react";
import "./About_content.css";
import Common_title from "../../common-components/common-title/Common_title";

const About_content = () => {
  return (
    <>
      <section className="About_content_sec">
        <div className="container">
          <Common_title
            title="ABOUT US"
            subtitle="Welcome to Bazarwala"
            logo={process.env.PUBLIC_URL + "/assets/images/logo/bazar-wala.png"}
          />

          <div className="row mt-4">
            <div className="col-md-12 mx-auto">
              <div className="cont_div">
                <p className="abtcont">
                  At Bazarwala, we believe grocery shopping should be simple,
                  fresh, and affordable. Our platform brings daily essentials,
                  snacks, household products, and quality groceries directly to
                  your doorstep with convenience and care.
                </p>
                <p className="abtcont">
                  We carefully select products to ensure freshness, quality, and
                  value for every customer. From traditional favorites to
                  everyday kitchen essentials, Bazarwala is your trusted online
                  destination for hassle-free shopping.{" "}
                </p>
                <hr />
                <p className="abtcont">
                  Our mission is to save your time while providing a smooth and
                  reliable shopping experience. With easy ordering, fast
                  delivery, and customer-focused service, we aim to make every
                  household shopping trip easier than ever.
                </p>
                <p className="abtcont">
                  Whether you are shopping for daily needs, festive treats, or
                  healthy snacks, Bazarwala is here to deliver freshness and
                  convenience right to your home.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About_content;
